import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import telegram from '../utils/telegram';
import api from '../api';
import './Home.css';

function Home() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [points, setPoints] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);

  const handleNavigation = (path) => {
    telegram.hapticLight();
    navigate(path);
  };

  useEffect(() => {
    // Получить данные пользователя из Telegram WebApp
    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.ready();
      tg.expand();

      const initDataUnsafe = tg.initDataUnsafe;
      if (initDataUnsafe.user) {
        setUser(initDataUnsafe.user);
        // Загрузить очки пользователя
        loadUserPoints(initDataUnsafe.user.id);
      }
    }

    // Слушать события обновления очков
    const handlePointsUpdate = (event) => {
      setPoints(event.detail);
    };

    window.addEventListener('pointsUpdated', handlePointsUpdate);

    return () => {
      window.removeEventListener('pointsUpdated', handlePointsUpdate);
    };
  }, []);

  const loadUserPoints = async (userId) => {
    try {
      // Load user info to check if admin
      const userRes = await api.get('/user/me');
      if (userRes.data) {
        setIsAdmin(userRes.data.is_admin || false);
      }

      // Load VERA points
      const veraRes = await api.get('/vera/balance');
      if (veraRes.data) {
        setPoints(veraRes.data.total_points || 0);
      }
    } catch (error) {
      console.error('Ошибка загрузки очков:', error);
      setPoints(0);
    }
  };

  const handleTelegramClick = () => {
    telegram.hapticLight();
    telegram.openTelegramLink('https://t.me/+wBXI4N49pwdhNDY1');
  };

  return (
    <div className="home-page">
      {/* Хедер с очками */}
      <div className="home-header">
        <div
          className="points-display clickable"
          onClick={() => handleNavigation('/profile')}
        >
          <span className="points-icon">⭐</span>
          <span className="points-value">{points}</span>
          <span className="points-label">VERA</span>
        </div>
        <div className="header-right">
          {user && (
            <div className="user-greeting">
              {user.first_name} 👋
            </div>
          )}
          <button className="telegram-chat-btn" onClick={handleTelegramClick} title="Присоединиться к чату">
            <svg className="telegram-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18.717-1.558 7.315-2.2 9.712-.271.996-.806 1.33-1.321 1.362-.563.035-1.175-.232-1.823-.58-1.011-.543-1.582-.88-2.563-1.41-1.133-.612-.399-1.013.247-1.601.169-.154 3.107-2.85 3.165-3.094.007-.031.014-.145-.054-.206s-.164-.04-.234-.024c-.1.024-1.688 1.073-4.764 3.149-.451.311-.86.462-1.226.454-.404-.009-1.18-.228-1.758-.416-.709-.23-1.272-.352-1.223-.743.025-.203.31-.41.855-.62 3.35-1.458 5.583-2.419 6.7-2.882 3.19-1.326 3.852-1.556 4.285-1.563.095-.002.307.022.445.134.116.094.148.221.163.31.015.088.034.29.019.447z"/>
            </svg>
          </button>
        </div>
      </div>

      {/* Главное меню */}
      <div className="main-menu">
        <h1 className="app-title">🔐 CyberDelia Elite</h1>
        <p className="app-subtitle">Подбери и протестируй конфигурацию</p>

        {/* Два главных раздела */}
        <div className="main-sections">
          {/* Подбор конфигурации */}
          <div
            className="main-section config-section"
            onClick={() => handleNavigation('/configurations')}
          >
            <div className="section-icon">🌐</div>
            <div className="section-content">
              <h2 className="section-title">Подбор конфигурации</h2>
              <p className="section-description">
                Готовые настройки для твоего провайдера
              </p>
              <div className="section-badge">Быстрый старт</div>
            </div>
            <div className="section-arrow">→</div>
          </div>

          {/* Тестирование */}
          <div
            className="main-section testing-section"
            onClick={() => handleNavigation('/testing')}
          >
            <div className="section-icon">🧪</div>
            <div className="section-content">
              <h2 className="section-title">Тестирование</h2>
              <p className="section-description">
                Помоги улучшить сервис и получай очки
              </p>
              <div className="section-badge points-badge">+10 очков за тест</div>
            </div>
            <div className="section-arrow">→</div>
          </div>

          {/* Приглашения */}
          <div
            className="main-section invite-section"
            onClick={() => handleNavigation('/invites')}
          >
            <div className="section-icon">🎁</div>
            <div className="section-content">
              <h2 className="section-title">Приглашай друзей</h2>
              <p className="section-description">
                Продлевай подписку бесплатно, покупай приглашения и развивай свободный интернет вместе
              </p>
              <div className="section-badge invite-badge">Получай бонусы</div>
            </div>
            <div className="section-arrow">→</div>
          </div>
        </div>

        {/* Дополнительные разделы */}
        <div className="secondary-sections">
          <div
            className="secondary-section"
            onClick={() => handleNavigation('/saved')}
          >
            <span className="secondary-icon">💾</span>
            <span className="secondary-title">Сохраненные конфигурации</span>
            <span className="secondary-arrow">→</span>
          </div>

          <div
            className="secondary-section"
            onClick={() => handleNavigation('/downloads')}
          >
            <span className="secondary-icon">📥</span>
            <span className="secondary-title">Скачать Happ</span>
            <span className="secondary-arrow">→</span>
          </div>

          <div
            className="secondary-section"
            onClick={() => handleNavigation('/profile')}
          >
            <span className="secondary-icon">⭐</span>
            <span className="secondary-title">Профиль</span>
            <span className="secondary-arrow">→</span>
          </div>

          {isAdmin && (
            <div
              className="secondary-section admin-section"
              onClick={() => handleNavigation('/admin/servers')}
            >
              <span className="secondary-icon">🔧</span>
              <span className="secondary-title">Управление серверами</span>
              <span className="secondary-arrow">→</span>
            </div>
          )}
        </div>

        {/* Информационный блок */}
        <div className="info-block">
          <div className="info-header">
            <h3 className="info-title">💡 Как это работает?</h3>
            <button
              className="help-button"
              onClick={() => setShowInstructions(!showInstructions)}
              title="Подробная инструкция"
            >
              ❓
            </button>
          </div>

          <div className="info-steps">
            <div className="info-step">
              <span className="step-number">1</span>
              <span className="step-text">Выбери провайдера и время суток</span>
            </div>
            <div className="info-step">
              <span className="step-number">2</span>
              <span className="step-text">Получи конфигурацию для Happ</span>
            </div>
            <div className="info-step">
              <span className="step-number">3</span>
              <span className="step-text">Протестируй и получи очки</span>
            </div>
          </div>

          {/* Подробная инструкция */}
          {showInstructions && (
            <div className="detailed-instructions">
              <h4>📚 Подробная инструкция</h4>

              <div className="instruction-section">
                <h5>🔍 Подбор конфигурации</h5>
                <ul>
                  <li><strong>Выберите провайдера</strong> - ваш интернет-оператор (МТС, Мегафон и т.д.)</li>
                  <li><strong>Укажите время суток</strong> - когда вы планируете использовать</li>
                  <li><strong>Настройте параметры</strong> - или используйте рекомендованные</li>
                </ul>
              </div>

              <div className="instruction-section">
                <h5>🧪 Тестирование</h5>
                <ul>
                  <li><strong>Быстрый режим</strong> - готовые конфигурации по странам</li>
                  <li><strong>Расширенный режим</strong> - настройка всех параметров вручную</li>
                  <li><strong>Запустите тест</strong> - проверьте скорость и стабильность</li>
                  <li><strong>Отметьте результат</strong> - работает или нет (получите очки!)</li>
                </ul>
              </div>

              <div className="instruction-section">
                <h5>💾 Сохраненные конфигурации</h5>
                <ul>
                  <li><strong>Мои конфигурации</strong> - ваши сохраненные настройки</li>
                  <li><strong>Топ конфигураций</strong> - проверенные другими пользователями</li>
                  <li><strong>Фильтр по странам</strong> - выбирайте нужную локацию</li>
                  <li><strong>Оценивайте</strong> - помогайте другим найти рабочие настройки</li>
                </ul>
              </div>

              <div className="instruction-section">
                <h5>⭐ Система очков</h5>
                <ul>
                  <li>+10 очков за тестирование конфигурации</li>
                  <li>Очки начисляются за честные отзывы</li>
                  <li>Помогите сообществу - делитесь опытом</li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;
